import React from "react";
import "./Loader.scss";

function Loader({ size = "normal" }) {
  return (
    <div className={`loader ${size}-size`} data-testid="loader">
      <svg width="100" height="100">
        <circle cx="50" cy="50" r="45" />
      </svg>
    </div>
  );
}

export default Loader;
